/**
 * Convert a camelCase string to kebab-case.
 *
 * @param str String value to convert.
 * @returns String in kebab-case.
 */
export const camelCaseToKebabCase = (str: string): string =>
  str.replace(
    /[A-Z]+(?![a-z])|[A-Z]/g,
    ($: string, ofs: string) => (ofs ? '-' : '') + $.toLowerCase(),
  );

/**
 * Convert a string with spaces into kebab case
 * @param sentence Full string with spaces
 * @returns String with spaces replaced by dashes
 */
export function sentenceToKebabCase(sentence: string | undefined) {
  if (!sentence) {
    return false;
  }

  return sentence.replace(/\W/g, '-');
}

/**
 * Convert a string to url-friendly kebab-case.
 *
 * @param str String value to convert.
 * @returns String in kebab-case.
 */
export const urlKebabCase = (str: string): string =>
  str
    .replace(/([a-z0–9])([A-Z])/g, '$1-$2')
    .replace('/', '-')
    .replace(/[^a-zA-Z0-9-]/g, '')
    .toLowerCase();

/**
 * Tests whether a string is kebab-cased
 * @param str string to test
 * @returns boolean
 */
export const isKebabCased = (str: string) => {
  return /^([a-z](?![\d])|[\d](?![a-z]))+(-?([a-z](?![\d])|[\d](?![a-z])))*$|^$/.test(
    str,
  );
};
